var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"title":_vm.title,"popover":_vm.popover}},[_c('div',{staticClass:"big-number"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }